import ResultsStore from "@/store/results";
import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions } from "firebase/firestore";
import Team from "./team";

export default interface Player {
  id: string;
  name: string;
  teamId: string;
  team: Team;
}

export class PlayerConverter implements FirestoreDataConverter<Player> {
  constructor(private results: ResultsStore) {}

  toFirestore(player: Player): DocumentData {
    return player;
  }

  fromFirestore(snapshot: QueryDocumentSnapshot<DocumentData>, options: SnapshotOptions): Player {
    const player = {
      id: snapshot.id,
      ...snapshot.data(options)
    } as Player;

    player.team = this.results.teamsById[player.teamId];

    return Object.freeze(player);
  }
}
